import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ArrowUp, ArrowDown } from "lucide-react";

export type SortField = "promise_time" | "order_no";
export type SortDirection = "asc" | "desc";

interface OrderSortingProps {
  sortField: SortField;
  sortDirection: SortDirection;
  onSortFieldChange: (field: SortField) => void;
  onSortDirectionChange: (direction: SortDirection) => void;
}

const OrderSorting = ({
  sortField,
  sortDirection,
  onSortFieldChange,
  onSortDirectionChange,
}: OrderSortingProps) => {
  return (
    <div className="space-y-2">
      <h3 className="text-xs font-bold uppercase tracking-wide text-muted-foreground">Sort by</h3>
      <div className="flex flex-wrap items-center gap-2">
        <Select value={sortField} onValueChange={(value: SortField) => onSortFieldChange(value)}>
          <SelectTrigger className="h-11 w-[160px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="promise_time">Promise time</SelectItem>
            <SelectItem value="order_no">Order number</SelectItem>
          </SelectContent>
        </Select>

        <Button
          variant="outline"
          onClick={() => onSortDirectionChange(sortDirection === "asc" ? "desc" : "asc")}
          className="h-11 gap-2 px-4 text-sm font-medium"
          aria-label={`Sorted ${sortDirection === "asc" ? "ascending" : "descending"}, tap to reverse`}
        >
          {sortDirection === "asc" ? (
            <>
              <ArrowUp className="h-4 w-4" />
              <span>Ascending</span>
            </>
          ) : (
            <>
              <ArrowDown className="h-4 w-4" />
              <span>Descending</span>
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export default OrderSorting;
